"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _decorators = require("decorators");

var _class;

// <Root>{(Target, Element) => <tree><Target><SingleNode/></Target>...<Element><SingleNode/></Element></tree>}</Root>
// If <Target> is used, it's contents will be rendered, unless an <Element> is rendered as well, in which case <Target> will go unused and <Element> will be rendered instead.
var Counter = 0;

var Root =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(Root, _Component);

  function Root(props) {
    var _this;

    babelHelpers.classCallCheck(this, Root);
    var C = ++Counter;
    _this = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(Root).call(this, props));
    var node = document.createElement('div');
    node.dataset.rootIndex = C;
    _this.state = {
      index: C,
      renderTarget: RenderTarget.bindTo(babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)), node, C),
      renderElement: RenderElement.bindTo(babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)), node, C),
      currentRenderTarget: null,
      currentRenderElement: null
    };
    return _this;
  }

  babelHelpers.createClass(Root, [{
    key: "render",
    value: function render() {
      var F = this.props.children;
      return _react.default.createElement("div", {
        "data-root-container-index": this.state.index
      }, F(this.state.renderTarget, this.state.renderElement));
    }
  }, {
    key: "__forceUpdate",
    value: function __forceUpdate() {
      if (this.currentRenderTarget) {
        this.currentRenderTarget.__updateContent();
      }
    }
  }]);
  return Root;
}(_react.Component);

exports.Root = Root;
var RenderTarget = (_class =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(RenderTarget, _Component2);
  babelHelpers.createClass(RenderTarget, null, [{
    key: "bindTo",
    value: function bindTo(root, element, value) {
      return (
        /*#__PURE__*/
        function (_RenderTarget) {
          babelHelpers.inherits(BoundRenderTarget, _RenderTarget);

          function BoundRenderTarget() {
            babelHelpers.classCallCheck(this, BoundRenderTarget);
            return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(BoundRenderTarget).apply(this, arguments));
          }

          babelHelpers.createClass(BoundRenderTarget, [{
            key: "getCounter",
            value: function getCounter() {
              return value;
            }
          }, {
            key: "getContainer",
            value: function getContainer() {
              return element;
            }
          }, {
            key: "getRoot",
            value: function getRoot() {
              return root;
            }
          }]);
          return BoundRenderTarget;
        }(RenderTarget)
      );
    }
  }]);

  function RenderTarget(props) {
    var _this2;

    babelHelpers.classCallCheck(this, RenderTarget);
    _this2 = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(RenderTarget).call(this, props));
    _this2.localElement = document.createElement('div');
    _this2.localElement.dataset.renderTargetIndex = _this2.getCounter();
    return _this2;
  }

  babelHelpers.createClass(RenderTarget, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.children) _reactDom.default.render(_react.default.Children.only(this.props.children), this.localElement);
      this.getRoot().currentRenderTarget = this;

      this.getRoot().__forceUpdate();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.children) _reactDom.default.unmountComponentAtNode(this.localElement);
      this.getRoot().currentRenderTarget = null;

      this.getRoot().__forceUpdate();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.children) _reactDom.default.render(_react.default.Children.only(this.props.children), this.localElement);else _reactDom.default.unmountComponentAtNode(this.localElement);
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        "data-index": this.getCounter(),
        ref: this.gotWrapper
      });
    }
  }, {
    key: "gotWrapper",
    value: function gotWrapper(node) {
      if (node != this.wrapperElement) {
        this.wrapperElement = node;

        if (node) {
          node.appendChild(this.getContainer());
        }
      }
    } // This is the element that actually holds the React tree.

  }, {
    key: "__getChildren",
    value: function __getChildren() {
      return (this.getRoot().currentRenderElement || this).localElement;
    }
  }, {
    key: "__updateContent",
    value: function __updateContent() {
      var C = this.__getChildren();

      var CNT = this.getContainer();

      if (CNT.firstChild != C) {
        if (CNT.firstChild) CNT.removeChild(CNT.firstChild);
        CNT.appendChild(C);
      }
    }
  }]);
  return RenderTarget;
}(_react.Component), (babelHelpers.applyDecoratedDescriptor(_class.prototype, "gotWrapper", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "gotWrapper"), _class.prototype)), _class);

var RenderElement =
/*#__PURE__*/
function (_Component3) {
  babelHelpers.inherits(RenderElement, _Component3);
  babelHelpers.createClass(RenderElement, null, [{
    key: "bindTo",
    value: function bindTo(root, container, index) {
      return (
        /*#__PURE__*/
        function (_RenderElement) {
          babelHelpers.inherits(BoundRenderElement, _RenderElement);

          function BoundRenderElement() {
            babelHelpers.classCallCheck(this, BoundRenderElement);
            return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(BoundRenderElement).apply(this, arguments));
          }

          babelHelpers.createClass(BoundRenderElement, [{
            key: "getCounter",
            value: function getCounter() {
              return index;
            }
          }, {
            key: "getRoot",
            value: function getRoot() {
              return root;
            }
          }, {
            key: "getContainer",
            value: function getContainer() {
              return container;
            }
          }]);
          return BoundRenderElement;
        }(RenderElement)
      );
    }
  }]);

  function RenderElement(props) {
    var _this3;

    babelHelpers.classCallCheck(this, RenderElement);
    _this3 = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(RenderElement).call(this, props));
    _this3.localElement = document.createElement('div');
    _this3.localElement.dataset.renderElementIndex = _this3.getCounter();
    return _this3;
  }

  babelHelpers.createClass(RenderElement, [{
    key: "render",
    value: function render() {
      // This never outputs anything. Rather, the attached RenderTarget does.
      return null;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.children) _reactDom.default.render(_react.default.Children.only(this.props.children), this.localElement);
      this.getRoot().currentRenderElement = this;

      this.getRoot().__forceUpdate();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.children) _reactDom.default.render(_react.default.Children.only(this.props.children), this.localElement);else _reactDom.default.unmountComponentAtNode(this.localElement);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.children) _reactDom.default.unmountComponentAtNode(this.localElement);
      this.getRoot().currentRenderElement = null;

      this.getRoot().__forceUpdate();
    }
  }]);
  return RenderElement;
}(_react.Component);